import { useNavigate } from 'react-router-dom';
import { Container } from './GetStartedAddress.styles';
import { PropertyCard } from '@/components/Layout/PropertyCard/PropertyCard';
import { MapOut } from '@/components/image/MapOut/MapOut';
import { NavigationButton, PageOrigin } from '@components/Button/NavigationButton/NavigationButton';
import { useAppDispatch, useAppSelector } from '@app/hooks';
import { selectOpenWarningChangesModal, setOpenWarningChangesModal } from '@/reducers/currentPage';

import { useDataChangeDetection } from '@/hooks/useDataChangeDetection';
import { DefaultModal } from '@/components/Modals/DefaultModal/DefaultModal';

interface GetStartedAddressProps {
  onAccess: (page: string) => void;
  pageOrigin: PageOrigin;
}

const GetStartedAddress: React.FC<GetStartedAddressProps> = ({ onAccess }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  let templateConfig = useAppSelector((state) => state.TemplateConfig);
  const openWarningChangesModal = useAppSelector(selectOpenWarningChangesModal);

  const { hasDataChanged, resetChangeDetection } = useDataChangeDetection([
    'propertyStreetAddress',
    'propertyCity',
    'propertyState',
    'propertyCountry',
    'propertyCounty',
    'propertyZip',
    'propertyLatitude',
    'propertyLongitude',
  ]);

  const handleWarningChangesModalClose = () => {
    dispatch(setOpenWarningChangesModal(false));
  };

  return (
    <>
      <Container>
        <PropertyCard />
        <MapOut />
      </Container>
      {openWarningChangesModal && (
        <DefaultModal
          openModal={openWarningChangesModal}
          setOpenModal={handleWarningChangesModalClose}
          isErrorModal={false}
          infoModal={{
            body:
              templateConfig?.pages?.LetsGetStartedAddress?.modals?.warningMessagePropertyChanges?.text ||
              'The property address information has changed from the last time it was entered. This may affect your estimated available equity.',
            button: templateConfig?.pages?.LetsGetStartedAddress?.modals?.warningMessagePropertyChanges?.button || 'Ok',
          }}
        />
      )}
      <NavigationButton
        variant="primary"
        nextButton={templateConfig?.pages?.LetsGetStartedAddress?.NavigationButton?.nextButton || 'Next'}
        isBackButton={templateConfig?.pages?.LetsGetStartedAddress?.NavigationButton?.backButton?.isHidden || false}
        backButton={templateConfig?.pages?.LetsGetStartedAddress?.NavigationButton?.backButton?.text || 'Back'}
        disabled={false}
        type="next"
        onAccess={onAccess}
        navigation={navigate}
        pageOrigin={PageOrigin.GET_STARTED}
        currentPage={PageOrigin.GET_STARTED_ADDRESS}
        destinationPage={PageOrigin.ESTIMATED_AVAILABLE_EQUITY}
        hasDataChanged={hasDataChanged}
        resetChangeDetection={resetChangeDetection}
      />
    </>
  );
};

export default GetStartedAddress;
